import { Component, Input } from '@angular/core';
import { GraphContainer } from 'src/app/model/generic-graph';

@Component({
  selector: 'app-potash-avg-price',
  templateUrl: './potash-avg-price.component.html',
  styleUrls: ['./potash-avg-price.component.scss']
})
export class PotashAvgPriceComponent {
  @Input() graphData: GraphContainer = {} as GraphContainer;
}
